import { PaymentDeferralAcceptanceMethod as GqlPaymentDeferralAcceptanceMethod } from '@willow/graphql-iso/src/app';
import { assertNever, PaymentDeferralAcceptanceMethod } from '@willow/types-iso';

export const getPaymentDeferralAcceptanceMethodLabel = (
  method: PaymentDeferralAcceptanceMethod | GqlPaymentDeferralAcceptanceMethod,
): string => {
  switch (method) {
    case 'sign':
    case GqlPaymentDeferralAcceptanceMethod.Sign:
      return 'Sign';
    case 'call':
    case GqlPaymentDeferralAcceptanceMethod.Call:
      return 'Call';
    case 'other':
    case GqlPaymentDeferralAcceptanceMethod.Other:
      return 'Other';
    default:
      assertNever(method);
  }
};
